module.exports = __webpack_public_path__ + "static/media/pipes-logo@3x.26894774.png";